import Vue from 'vue'
import Router from 'vue-router'

// Containers
import DefaultContainer from '@/components/container/DefaultContainer'

// Views
import Dashboard from '@/components/dashboard/Dashboard'
import Login from '@/components/auth/Login'
import Register from '@/components/auth/Register'
import News from '@/components/news/News'
import Funding from '@/components/funding/Funding'
import FundingDetail from '@/components/funding/DetailFunding'
import Payment from '@/components/pembayaran/Pembayaran'
import Penyaluran from '@/components/penyaluran/Penyaluran'
import Posko from '@/components/posko/Posko'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            requiresAuth: true 
          }  
        },
        {
          path: 'news',
          name: 'News',
          component : News,
          meta: {
            requiresAuth: true 
          }  
        },
        {
          path: 'funding',
          name : 'Funding',
          component : Funding,
          meta: {
            requiresAuth: true 
          }  
        },
        {
          path: 'funding/:id',
          name : 'FundingDetail',
          component : FundingDetail,
          meta: {
            requiresAuth: true 
          }  
        },
        {
          path: 'payment',
          name: 'Payment',
          component : Payment,
          meta: {
            requiresAuth: true 
          }  
        },
        {
          path: 'penyaluran',
          name: 'Penyaluran',
          component : Penyaluran,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'posko/:id',
          name: 'Posko',
          component: Posko,
          meta: {
            requiresAuth : true
          }
        }
      ]
    },
    {
      path: '/auth',
      redirect: '/auth/login',
      name: 'Auth',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login,
        },
        {
          path: 'register',
          name: 'Register',
          component: Register,
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js